import { render } from "./ScoreT.vue?vue&type=template&id=22b8ac8e&scoped=true"
import script from "./ScoreT.vue?vue&type=script&lang=js"
export * from "./ScoreT.vue?vue&type=script&lang=js"

import "./ScoreT.vue?vue&type=style&index=0&id=22b8ac8e&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b8ac8e"]])

export default __exports__